const AIFeedbackSvg = () => (
  <svg
    width="29"
    height="28"
    viewBox="0 0 29 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28.9122 8.78568L26.7738 9.95498L25.6045 12.0933L24.4352 9.95498L22.2969 8.78568L24.4352 7.61638L25.6045 5.47803L26.7738 7.61638L28.9122 8.78568Z"
      fill="currentColor"
    />
    <path
      d="M10.6544 24.0035L8.51602 25.1728L7.34672 27.3111L6.17741 25.1728L4.03906 24.0035L6.17741 22.8341L7.34672 20.6958L8.51602 22.8341L10.6544 24.0035Z"
      fill="currentColor"
    />
    <path
      d="M19.7036 13.0466L15.9912 15.0766L13.9612 18.7891L11.9312 15.0766L8.21875 13.0466L11.9312 11.0166L13.9612 7.3042L15.9912 11.0166L19.7036 13.0466Z"
      fill="currentColor"
    />
    <path
      d="M24.6544 24.6924L22.516 25.8617L21.3467 28.0001L20.1774 25.8617L18.0391 24.6924L20.1774 23.5231L21.3467 21.3848L22.516 23.5231L24.6544 24.6924Z"
      fill="currentColor"
    />
    <path
      d="M7.52937 3.30765L5.39102 4.47696L4.22171 6.6153L3.05241 4.47696L0.914062 3.30765L3.05241 2.13835L4.22171 0L5.39102 2.13835L7.52937 3.30765Z"
      fill="currentColor"
    />
  </svg>
);

export default AIFeedbackSvg;
